import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PasswordTextField } from 'src/components';
import Button from 'src/components/button';
import TextField from 'src/components/text-field';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';
import done from 'src/assets/images/Done.png';
import { BrowserRouter as Router, Route, useParams } from 'react-router-dom';
import axios from 'axios';
import OtpInput from 'react-otp-input';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  // password: Yup.string()
  //   .matches(
  //     /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#`$'"%^&*()_+{}\[\]:;<>,.?~\\/-])[\w!@#$`'"%^&*()_+{}\[\]:;<>,.?~\\/-]{8,20}$/,
  //     'Password must be at least one alpha numeric character, 8 character long, at least one numeric and up to.'
  //   )
  //   .required('Required'),
  // cPassword: Yup.string()
  //   .oneOf([Yup.ref('password'), null], 'Passwords must match')
  //   .required('Required'),
  businessName: Yup.string()
    .min(3, 'Name must be at least 3 character long')
    .required('Business name required'),
  fullName: Yup.string()
    .min(3, 'Name must be at least 3 character long')
    .required('Full name required'),
  phone: Yup.string()
    .test(
      'len',
      'Phone number must be exactly 10 digits',
      (val: any) => val && val.length === 10
    )
    .test(
      'prefix',
      'Phone number must start with 97 or 98',
      (val: any) => val && /^(97|98)/.test(val)
    )
    .test(
      'numeric',
      'Phone number must contain only numbers',
      (val: any) => val && /^\d+$/.test(val)
    )
    .required('Phone is required'),
  referralCode: Yup.string(),
  // country: Yup.string().required('Password is required'),
});

const Test: React.FC<IProps> = ({}) => {
  const searchParams = new URLSearchParams(window.location.search);
  const referralCode = searchParams.get('refCode');
  const [code, setCode] = React.useState('');

  const [errorMsg, setErrorMsg] = React.useState('');
  // const [passwordVisibleSwitch, setPasswordVisibleSwitch] =
  //   React.useState<boolean>(false);

  const [isRegSucess, setIsRegSuccess] = React.useState<boolean>(false);

  const navigate = useNavigate();

  const initVal = {
    fullName: '',
    email: '',
    password: '',
    phone: '',
    // country: 'nepal',
    businessName: '',
    cPassword: '',
  };

  const handleLogin = async (val: {
    email: string;
    password: string;
    phone: string;
    // country: string;
    businessName: string;
    fullName: string;
    referralCode?: string;
  }) => {
    const lowercaseEmail = val.email.toLowerCase();

    const payload = {
      ...val,
      email: lowercaseEmail,
      pin: code,
    };

    referralCode ? (payload.referralCode = referralCode) : null;
    try {
      const { data } = await Service.post('/auth/business/register', payload);
      // navigate('/login');
      setIsRegSuccess(!isRegSucess);
      toastAlert('success', 'Please Enter Otp Sent to your Email.');

      navigate('/otp', {
        state: {
          ...payload,
        },
      });
      toastAlert('success', data?.message ?? 'Something went wrong.');
    } catch (err: any) {
      setErrorMsg(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Service.post('/partners/click/' + referralCode);
      } catch (error: any) {
        console.error('Error fetching data:', error?.message);
      }
    };

    if(referralCode) fetchData();

    referralCode ? fetchData : null;
  }, [referralCode]);

  const handleChange = (code: string) => {
    setCode(code);
  };

  return (
    <>
      <Formik
        initialValues={initVal}
        onSubmit={handleLogin}
        validateOnMount
        validationSchema={FORM_VALIDATION}
      >
        {({ isSubmitting, isValid }) => (
          <Form className="mt-5 ">
            <h1 className="text-4xl font-semibold mb-5">Register</h1>

            {errorMsg && (
              <p className="text-center text-warning font-semibold">
                {errorMsg}
              </p>
            )}
            {referralCode ? (
              <TextField
                type="hidden"
                name="referralCode"
                defaultValue={referralCode}
              />
            ) : null}
            <TextField
              label="Full Name"
              name="fullName"
              placeholder="Enter your Full name"
            />
            <TextField
              label="Email"
              name="email"
              placeholder="Enter your email address"
            />
            <TextField
              label="Business Name"
              name="businessName"
              placeholder="Enter your business name"
            />

            <TextField
              label="Mobile Number"
              name="phone"
              placeholder="Enter your mobile number"
            />

            <PasswordTextField label="Password" name="password" />
            <PasswordTextField label="Confirmd" name="cPassword" />

            <div className="flex flex-col  justify-between mt-6">
              <h2>Pin</h2>
              <OtpInput
                value={code}
                onChange={(newCode: string) => handleChange(newCode)}
                numInputs={4}
                separator={<span style={{ width: '20px' }}></span>}
                isInputNum={true}
                shouldAutoFocus={true}
                className="mt-5 ds"
                placeholder={'----'}
                containerStyle={{
                  justifyContent: 'space-between',
                }}
                inputStyle={{
                  border: '1px solid #CACFE3',
                  borderRadius: '8px',
                  width: '64px',
                  height: '64px',
                  fontSize: '15px',
                  color: '#000',
                  fontWeight: '400',
                }}
                focusStyle={{
                  border: '1px solid #4062FF',
                  outline: 'none',
                }}
              />
            </div>
            {/* <p
              onClick={() => navigate('/forget-password')}
              className="text-primary text-xs font-semibold text-end cursor-pointer"
            >
              Forget Password?
            </p> */}
            <Button
              text="Register"
              type="submit"
              variant="primary"
              className="w-full mt-5"
              isSubmitting={isSubmitting}
              isValid={isValid}
            />
            <p className="mt-5 text-left">
              {`By signing up you agree to our `}
              <span
                className="text-primary font-medium mx-0 cursor-pointer "
                onClick={() => navigate('/term-of-use')}
              >
                {`Terms of Use`}
              </span>
              {` and `}
              <span
                className="text-primary font-medium mx-0 cursor-pointer "
                onClick={() => navigate('/privacy-notice')}
              >
                {` Privacy Notice`}
              </span>
            </p>
          </Form>
        )}
      </Formik>
      <div className="flex items-center justify-center">
        <p className="mt-5 text-center">
          {`Already have an account?`}
          <span
            className="text-primary font-semibold mx-2 cursor-pointer "
            onClick={() => navigate('/login')}
          >
            Login
          </span>
        </p>
      </div>

      {isRegSucess && (
        <div className="fixed bg-pure-white z-30 top-0 left-0 h-full w-full flex flex-col items-center justify-center gap-12">
          <svg
            width={116}
            height={24}
            viewBox="0 0 116 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_5915_21170)">
              <path
                d="M60.1263 23.1726L68.364 0.827721H63.93L57.8988 17.7519L51.8677 0.827721H47.4336L55.6713 23.1726H60.1263ZM87.68 12.4553C87.68 17.7519 85.0742 19.676 81.922 19.676C77.0887 19.676 76.1851 15.2898 76.1851 11.8139V0.827721H71.73V13.2415C71.73 16.6967 72.8858 23.7726 80.7032 23.7726C83.9814 23.7726 86.5452 22.5725 88.2053 20.5036V23.1726H92.114V0.827721H87.68V12.4553ZM106.687 23.7726C112.424 23.7726 115.891 21.1243 115.891 16.6967C115.891 13.2415 113.937 11.5243 108.221 10.076C102.904 8.75186 101.875 8.17255 101.875 6.68289C101.875 4.98634 103.682 3.91048 106.351 4.01393C109.125 4.11738 110.953 5.44151 111.268 7.57255L115.765 6.76565C115.261 2.79324 111.52 0.207031 106.309 0.207031C100.971 0.207031 97.4826 2.85531 97.4826 6.91048C97.4826 10.2001 99.4159 11.7932 105.279 13.3036C110.617 14.7105 111.373 15.1657 111.373 16.8622C111.373 18.807 109.713 19.9657 106.981 19.9657C103.955 19.9657 101.812 18.5588 101.244 16.2208L96.747 16.9036C97.5246 21.2691 101.16 23.7726 106.687 23.7726Z"
                fill="#11152B"
              />
              <path
                d="M11.6506 0.227783C8.37238 0.227783 5.80861 1.42778 4.14846 3.49675V0.827784H0.21875V23.1726H4.67382V11.545C4.67382 6.24847 7.27962 4.32434 10.4318 4.32434C15.2651 4.32434 16.1688 8.71054 16.1688 12.1864V23.1726H20.6238V10.7588C20.6238 7.30365 19.468 0.227783 11.6506 0.227783Z"
                fill="#11152B"
              />
              <mask
                id="mask0_5915_21170"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x={23}
                y={0}
                width={24}
                height={24}
              >
                <path
                  d="M35.025 23.9991C41.5243 23.9991 46.7931 18.8118 46.7931 12.4129C46.7931 6.01398 41.5243 0.82666 35.025 0.82666C28.5256 0.82666 23.2568 6.01398 23.2568 12.4129C23.2568 18.8118 28.5256 23.9991 35.025 23.9991Z"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_5915_21170)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M49.8179 11.1727C49.0401 11.9388 47.951 12.3156 46.8574 12.197L36.2577 11.048C34.5527 10.8632 33.2123 9.52744 33.0456 7.84661L32.0288 -2.40343C31.9234 -3.46621 32.3067 -4.51968 33.0736 -5.27477L36.4082 -8.55774C38.5679 -10.6841 42.2667 -9.3898 42.5791 -6.39852L43.0409 -1.9746C43.2149 -0.308117 44.5425 1.01506 46.2329 1.20681L51.0684 1.75528C54.0822 2.0971 55.3624 5.71415 53.2172 7.82593L49.8179 11.1727ZM33.0929 30.0869C32.3148 29.3208 31.9324 28.2485 32.0526 27.1719L33.2196 16.736C33.4073 15.0574 34.7643 13.7379 36.4712 13.5735L46.8824 12.5724C47.9619 12.4687 49.0317 12.8461 49.7989 13.6011L53.1332 16.8841C55.2929 19.0105 53.9785 22.6521 50.9401 22.9597L46.4467 23.4143C44.754 23.5857 43.4102 24.893 43.2155 26.557L42.6584 31.3178C42.3113 34.285 38.6374 35.5454 36.4922 33.4337L33.0929 30.0869ZM16.8426 12.5961C15.749 12.4775 14.6599 12.8543 13.8819 13.6201L10.4826 16.9669C8.33752 19.0789 9.61789 22.696 12.6315 23.0378L17.467 23.5862C19.1574 23.7779 20.485 25.1012 20.659 26.7677L21.1209 31.1914C21.4333 34.1829 25.1321 35.477 27.2918 33.3506L30.6264 30.0679C31.3933 29.3128 31.7766 28.2593 31.6712 27.1964L30.6544 16.9465C30.4877 15.2656 29.1472 13.9297 27.4423 13.7448L16.8426 12.5961ZM30.6071 -5.29383C31.3849 -4.52787 31.7676 -3.45557 31.6471 -2.37885L30.4804 8.0571C30.2927 9.73572 28.9357 11.0552 27.2285 11.2193L16.8176 12.2204C15.7381 12.3244 14.6681 11.9468 13.9012 11.1917L10.5667 7.90896C8.40698 5.7825 9.72156 2.14082 12.7598 1.83332L17.2532 1.3785C18.9458 1.20719 20.2898 -0.0998688 20.4845 -1.76412L21.0416 -6.52483C21.3888 -9.49192 25.0626 -10.7525 27.2077 -8.64059L30.6071 -5.29383Z"
                  fill="url(#paint0_linear_5915_21170)"
                />
              </g>
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_5915_21170"
                x1="47.4234"
                y1="-2.93631"
                x2="16.7616"
                y2="28.2071"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4062FF" />
                <stop offset={1} stopColor="#9484DC" />
              </linearGradient>
              <clipPath id="clip0_5915_21170">
                <rect width={116} height={24} fill="white" />
              </clipPath>
            </defs>
          </svg>
          <div className="w-[28.9rem] min-h-96 px-12 pt-5 pb-12 bg-white rounded-xl shadow-[10px_10px_50px_0px_rgba(45,87,226,0.10)]  border-almost-white flex-col justify-start items-center inline-flex">
            <img
              className="w-72 h-72 animate-[slideUp_1s_linear_infinite]"
              src={done}
            />
            <div className="flex-col justify-start items-center gap-2 flex ">
              <div className=" text-2xl font-semibold">
                Registration Successful
              </div>
              <div className="text-center text-secondary-0 text-sm font-normal leading-snug">
                Congratulations! Your registration process is completed. Our
                representatives will get in contact with you soon.
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Test);
